/**
 * Seamly Channel API
 * The API for Seamly Channel REST API <br/><br/> **Please note**: You can view which schemas apply to an endpoint by navigating to the response of an endpoint and then clicking on *Schema*, right next to *Example Value*. By default example values are shown for each response.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@seamly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActionBodyPickChoiceChoice } from './action-body-pick-choice-choice';

export interface ActionBodyPickChoice {
    type: ActionBodyPickChoice.TypeEnum;
    /**
     * Identifier of the transaction this message belongs to. Aids to group and link messages together. When a bot service for instance emits multiple messages at once they\'ll all have the same transactionId.
     */
    transactionId: string | null;
    /**
     * ID of the related message with the choice prompt
     */
    originMessage: string;
    choice: ActionBodyPickChoiceChoice;
}
export namespace ActionBodyPickChoice {
    export type TypeEnum = 'pick_choice';
    export const TypeEnum = {
        PickChoice: 'pick_choice' as TypeEnum
    };
}
